module.exports = __webpack_public_path__ + "img/pageAccueil.66387895.jpg";